<!-- 活动评选分析 -->
<template>
  <div class="activity-review">
        <div class="activity-review-top">
            <div class="title">活动评审</div>
            <div class="more" @click="goMore">更多 ></div>
            <img class="title-bg" :src="require('@/assets/images/sydataboard/title-bg.png')" alt="">
        </div>
        <div class="activity-review-number">
            <div class="activity-review-number-item" v-for="(item,index) in activityNumList" :key="index">
                <div class="name">{{ item.name }}</div>
                <!-- <div class="number">{{ item.number }}</div> -->
                <count-up
                    class="infor-card-count user-created-count"
                    :id-name="`code_${item.name}`"
                    :end-val="item.number"
                    color="#FFFFFF"
                    countSize="16px"
                    :countWeight="700"
                    :isConvert="1"
                    style="height:100%;"
                >
                </count-up>
            </div>
        </div>
        <div class="activity-review-progress">
            <div class="rank-li" v-for="(item,index) in activityList" @click="goActivityReviewInfo(item)" :key="item.id">
                <div class="subject-name">{{ item.title }}</div>
                <div class="rate">
                    <el-progress class="rank-progress" :color="'#2B7FFF'" :duration="3" :intermediate="true" :show-text="false" :percentage="item.progress" :stroke-width="12"></el-progress>
                    <div class="number">{{ item.number }}</div>
                </div>
            </div>
        </div>
        <img class="top-left" :src="require('@/assets/images/sydataboard/top-left.png')" alt="">
        <img class="top-right" :src="require('@/assets/images/sydataboard/top-right.png')" alt="">
        <img class="left-bottom" :src="require('@/assets/images/sydataboard/left-bottom.png')" alt="">
        <img class="right-bottom" :src="require('@/assets/images/sydataboard/right-bottom.png')" alt="">
    </div>
</template>

<script>
import { getActivityReviewInfoAPI } from "@/service/api.js"
import CountUp from "@/components/countUp.vue";
export default {
  name: 'activity-review',
  components: {
    CountUp
  },
  props:{
    //请求参数
    params: {
        type: Object,
        default: ()=>{}
    },
  },
  data() {
      return {
            activityNumList:[],
            activityList:[],
      }
  },
  watch:{
    params: {
      deep: true,
      handler (val) {
        this.getActivityReviewInfo();
      }
    }
  },
  methods: {
    /**
     * @name 活动评审跳转更多
     */
    goActivityReviewInfo(item){
        window.open(`https://jzjx.syjy.cn/teachermain/evaluate/management/participatePersonRegion/1002/${item.id}?token=${this.$store.getters.token}`,'_blank')
    },
    /**
     * @name 跳转更多
     */
    goMore(){
        window.open(`https://jzjx.syjy.cn/evaluate/?token=${this.$store.getters.token}`,'_blank')
    },
    /**
     * @name 获取活动评审数据统计
     */
    getActivityReviewInfo(){
        this.activityNumList = []
        getActivityReviewInfoAPI({...this.params}).then((res)=>{
            let numberList = [];
            let rankList = [];
            numberList.push({
                name:'活动数',
                number:res.activityReviewInfo.activityNum
            })
            numberList.push({
                name:'作品提交数',
                number:res.activityReviewInfo.submitWorksNum
            })
            numberList.push({
                name:'获奖作品数',
                number:res.activityReviewInfo.awardsWorksNum
            })
            this.$emit("activity-number",res.activityReviewInfo.activityNum)
            //获取活动参与人数最多的人数
            let maxNum = res.topActivityReview.length > 0 ? res.topActivityReview[0].worksNum : 0
            rankList = res.topActivityReview.map((item)=>{
                return {
                    id:item.activityId,
                    title:item.title,
                    number:item.worksNum,
                    progress:Number(item.worksNum/maxNum * 100)
                }
            });
            this.activityNumList = numberList
            this.activityList = rankList;
        }).catch((err)=>{
            this.$Message.error('活动评审数据统计获取失败！');
        })
    }
  },
  mounted(){ 
    //获取活动评审数据
    this.getActivityReviewInfo();
  },
}
</script>

<style lang="scss" scoped>
.activity-review{
    width: calc(50% - 10px);
    height: 215px;
    padding: 0 15px;
    background: rgba(6,17,52,0.8);
    border: 1px solid #053882;
    // box-shadow: 0px 0px 10px 0px rgba(14,252,255,0.77);
    margin-bottom: 20px;
    position: relative;
    .activity-review-top{
        position: relative;
        text-align: center;
        margin-bottom: 14px;
        .title{
            display: inline-block;
            padding: 9px 22px 8px 17px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #D0E7FE;
            line-height: 20px;
            position: relative;
            z-index: 2;
        }
        .more{
            display: inline-block;
            position: absolute;
            top: 0px;
            right: 0px;
            height: 100%;
            line-height: 44px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #359AFF;
            cursor: pointer;
        }
        .title-bg{
            width: auto;
            height: 100%;
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
        }
    }
    .activity-review-number{
        display: flex;
        align-items: center;
        justify-content: space-around;
        margin-bottom: 14px;
        .activity-review-number-item{
            display: flex;
            align-items: center;
            .name{
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #7ABFDB;
                margin-right: 5px;
            }
            .number{
                font-size: 16px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                color: #FFFFFF;
            }
        }
    }
    .activity-review-progress{
        .rank-li{
            width: 100%;
            height: 16px;
            display: flex;
            align-items: center;
            margin-bottom: 9px;
            cursor: pointer;
            .subject-name{
                width: 100px;
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #6EA0D3;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                text-align: left;
                line-height: 16px;
            }
            .rate{
                width: calc(100% - 100px);
                display: flex;
                align-items: center;
                .rank-progress{
                    width: calc(100% - 75px);
                }
                .number{
                    margin-left: 5px;
                    display: inline-block;
                    width: 70px;
                    font-size: 14px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #7ABFDB;
                    text-align: right;
                    line-height: 16px;
                }
            }
        }
        .rank-li:last-child{
            margin-bottom: 0;
        }
    }
    .top-left{
        position: absolute;
        top: -1px;
        left: -1px;
        width: 14px;
        height: 14px;
    }
    .top-right{
        position: absolute;
        top: -1px;
        right: -1px;
        width: 14px;
        height: 14px;
    }
    .left-bottom{
        position: absolute;
        bottom: -1px;
        left: -1px;
        width: 14px;
        height: 14px;
    }
    .right-bottom{
        position: absolute;
        bottom: -1px;
        right: -1px;
        width: 14px;
        height: 14px;
    }
}
</style>
<style lang="scss">
.activity-review{
    .activity-review-progress{
        .rank-li{
            .rate{
                .el-progress-bar{
                    .el-progress-bar__outer{
                        background-color: transparent;
                        border-radius: 0;
                        .el-progress-bar__inner{
                            border-radius: 0;
                        }
                    }
                    .el-progress__text{
                        font-size: 14px;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        color: #6EA0D3;
                    }
                }
            }
        }
    }
}
</style>